import React from 'react';
import styled from 'styled-components';

const ModifyButton = ({ handleSubmit }) => {
  return (
    <ModifyButtonContainer
      className='w-100 btn btn-primary'
      onClick={handleSubmit}
    >
      <ModifyButtonText>저장하기</ModifyButtonText>
    </ModifyButtonContainer>
  );
};

const ModifyButtonContainer = styled.button``;
const ModifyButtonText = styled.h5``;

export default ModifyButton;
